import React from "react";
import module from "./CommonInput.module.css";
import { TextField } from "@mui/material";

const Email = () => {
  return (
    <div className={module.textfield}>
      <div>
        <span className={module.label}>メールアドレス</span>
      </div>
      <TextField id="email" variant="outlined" type="email" fullWidth />
    </div>
  );
};

export default Email;
